import React from 'react';
import SkeletonCard from '../../../components/Skeleton/Card';

export const LoadingPerformanceReview: React.FC = () => {
  return (
    <>
      <SkeletonCard height={250} />
      <SkeletonCard height={250} />
    </>
  );
};
